var UitkScrimType = {
  OVERLAY: 'overlay',
  BOTTOM: 'fade-bottom',
  LEADING: 'fade-leading',
  TRAILING: 'fade-trailing',
  BUTTON: 'fade-button'
};
var UitkScrimColorType = {
  PRIMARY: 'primary-background',
  SECONDARY: 'secondary-background'
};
export { UitkScrimColorType, UitkScrimType };